export default __webpack_public_path__ + "static/John_Szczepanski-4ad38c174d5d16e2f13e3de641830320.jpg";